/**
 * This file was auto-generated by client-types. Do not manually edit this file.
 * Your changes would be automatically overwritten.
 *
 * Service Documentation: https://private.hubteam.com/shoebill/service/com.hubspot.portals.platform.app.rpc.NavigationRpc
 */

import type {
  ChirpAvroRpcDetails,
  Requestify,
  unhandledEnumCase,
  Default,
  HubspotMetadata,
} from 'rpc-client-utils';

export type CausalChainLink = {
  coordinates: ChirpMethodCoordinates;
  errorClass: string;
  errorMessage?: string;
};

export type ChirpMethodCoordinates = { service: string; method: string };

export type MenuData = { menuId: number; items: Default<MenuItemData[]> };

export type MenuItemData = {
  label: string;
  url?: string;
  pageId?: number;
  contentType?: string;
  linkTarget?: string;
  isNonLinkingNode: boolean;
  children: Default<MenuItemData[]>;
};

export type NavigationItem = {
  id: string;
  path?: string;
  order?: number;
  external?: boolean;
  badge?: NavigationItemBadge;
  gate?: string;
  children: Default<NavigationItem[]>;
};

export type NavigationItemBadge = { count: number };

export type NavigationManifest = {
  portalInstanceType: PortalInstanceType;
  version: number;
  items: Default<NavigationItem[]>;
};

export type PortalInstanceType =
  | 'CUSTOMER'
  | 'BUYER'
  | 'BILLING'
  | 'REFERENCE'
  | 'CUSTOMER_SUCCESS'
  | 'DEAL_PLAN'
  | 'UNIVERSAL'
  | 'QUOTE'
  | 'TEAMWORK'
  | 'CUSTOM'
  | unhandledEnumCase;

export type PortalNavigationEntry = {
  portalInstanceId: number;
  displayName: string;
  portalInstanceType: PortalInstanceType;
  baseUrl: string;
  isCurrent: boolean;
  navigationManifest?: NavigationManifest;
  dynamicPortalObjects: Default<CrmObjectSummary[]>;
  hasMoreDynamicPortalObjects: Default<boolean>;
};

export const ConsentErrorTypename =
  'com.hubspot.portals.platform.models.rpc.ConsentError';
export type ConsentError = {
  reason: ConsentErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.ConsentError';
};

export const NotificationErrorTypename =
  'com.hubspot.portals.platform.models.rpc.NotificationError';
export type NotificationError = {
  reason: NotificationErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.NotificationError';
};

export const PortalAuthErrorTypename =
  'com.hubspot.portals.platform.models.rpc.PortalAuthError';
export type PortalAuthError = {
  reason: PortalAuthErrorReason;
  portalInstanceId?: number;
  denialReason?: string;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.PortalAuthError';
};

export type PortalPublicRpcError =
  | PortalAuthError
  | NotificationError
  | ConsentError
  | SettingsError
  | SupportPortalError;

export const SettingsErrorTypename =
  'com.hubspot.portals.platform.models.rpc.SettingsError';
export type SettingsError = {
  reason: SettingsErrorReason;
  passwordErrors: Default<string[]>;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.SettingsError';
};

export const SupportPortalErrorTypename =
  'com.hubspot.portals.platform.models.rpc.SupportPortalError';
export type SupportPortalError = {
  reason: SupportPortalErrorReason;
  chirpErrorMessage?: string;
  coordinates?: ChirpMethodCoordinates;
  causalChain: Default<CausalChainLink[]>;
  shouldRetry: Default<boolean>;
  __typename: 'com.hubspot.portals.platform.models.rpc.SupportPortalError';
};

export type ConsentErrorReason =
  | 'CONSENT_LABELS_NOT_FOUND'
  | 'UNEXPECTED_ERROR'
  | unhandledEnumCase;

export type NotificationErrorReason =
  | 'NOTIFICATION_NOT_FOUND'
  | 'INVALID_NOTIFICATION_TYPE'
  | 'MISSING_PORTAL_ID'
  | unhandledEnumCase;

export type PortalAuthErrorReason =
  | 'AUTHENTICATION_FAILED'
  | 'ACCESS_DENIED'
  | 'UNEXPECTED_ERROR'
  | 'INVALID_PARAMETER_COUNT'
  | 'INVALID_PARAMETER_TYPES'
  | 'MISSING_ACCOUNT_ID'
  | 'MISSING_PORTAL_INSTANCE_ID'
  | 'MISSING_MEMBERSHIP_COOKIE'
  | 'EMPTY_MEMBERSHIP_COOKIE'
  | 'CSRF_ERROR'
  | 'MISSING_CRM_OBJECT_ID'
  | 'MISSING_CRM_OBJECT_ASSOCIATION'
  | 'FORM_NOT_FOUND'
  | unhandledEnumCase;

export type SettingsErrorReason =
  | 'MISSING_REQUIRED_FIELD'
  | 'CONTACT_NOT_FOUND'
  | 'FILE_TOO_LARGE'
  | 'UNSUPPORTED_FILE_TYPE'
  | 'WRONG_CURRENT_PASSWORD'
  | 'INVALID_PASSWORD'
  | 'SAME_PASSWORD'
  | 'PASSWORD_LEAKED'
  | 'PASSWORDS_DO_NOT_MATCH'
  | 'RATE_LIMITED'
  | 'UNEXPECTED_ERROR'
  | unhandledEnumCase;

export type SupportPortalErrorReason =
  | 'SETTINGS_NOT_FOUND'
  | 'TICKET_NOT_FOUND'
  | 'THREAD_NOT_FOUND'
  | 'CONTACT_NOT_FOUND'
  | 'RESOURCE_NOT_FOUND'
  | unhandledEnumCase;

export type GetNavigationMenuRequest = {
  membershipToken?: string;
  utkCookie?: string;
  portalInstanceId?: number;
  accountId?: number;
  objectId?: number;
  membershipCsrfTokenFromClient?: string;
  membershipCsrfTokenFromCookie?: string;
  previewJwt?: string;
  companyId?: number;
};

export type GetNavigationMenuResponse = {
  menuId?: number;
  menuData?: MenuData;
  isDomainSpecific: boolean;
};

export type GetPortalNavigationManifestsRequest = {
  membershipToken?: string;
  utkCookie?: string;
  portalInstanceId?: number;
  accountId?: number;
  objectId?: number;
  membershipCsrfTokenFromClient?: string;
  membershipCsrfTokenFromCookie?: string;
  previewJwt?: string;
  companyId?: number;
};

export type GetPortalNavigationManifestsResponse = {
  manifest?: NavigationManifest;
};

export type GetPortalNavigationRequest = {
  membershipToken?: string;
  utkCookie?: string;
  portalInstanceId?: number;
  accountId?: number;
  objectId?: number;
  membershipCsrfTokenFromClient?: string;
  membershipCsrfTokenFromCookie?: string;
  previewJwt?: string;
  companyId?: number;
};

export type GetPortalNavigationResponse = {
  portalNavigationEntries: Default<PortalNavigationEntry[]>;
  siteMenuData?: MenuData;
};

export type CrmObjectSummary = {
  objectId: number;
  displayName: string;
  description?: string;
};

export type GetNavigationManifestsRequestType =
  Requestify<GetPortalNavigationManifestsRequest>;
export type GetNavigationManifestsResponseType =
  GetPortalNavigationManifestsResponse;
export type GetNavigationManifestsErrorType = PortalAuthError & HubspotMetadata;
export const getNavigationManifestsRpc: ChirpAvroRpcDetails<
  GetNavigationManifestsRequestType,
  GetNavigationManifestsResponseType,
  GetNavigationManifestsErrorType,
  false
> = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.NavigationRpc',
  rpcName: 'getNavigationManifests',
  auth: 'external',
  fingerprint: 'M51ZlwqwFM6tVUOxTfJWK0WCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetPortalNavigationRequestType =
  Requestify<GetPortalNavigationRequest>;
export type GetPortalNavigationResponseType = GetPortalNavigationResponse;
export type GetPortalNavigationErrorType = PortalAuthError & HubspotMetadata;
export const getPortalNavigationRpc: ChirpAvroRpcDetails<
  GetPortalNavigationRequestType,
  GetPortalNavigationResponseType,
  GetPortalNavigationErrorType,
  false
> = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.NavigationRpc',
  rpcName: 'getPortalNavigation',
  auth: 'external',
  fingerprint: '9H8oCgelsNevp42uprveA0WCN6N5rP_v',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};

export type GetNavigationMenuRequestType = Requestify<GetNavigationMenuRequest>;
export type GetNavigationMenuResponseType = GetNavigationMenuResponse;
export type GetNavigationMenuErrorType = PortalPublicRpcError & HubspotMetadata;
export const getNavigationMenuRpc: ChirpAvroRpcDetails<
  GetNavigationMenuRequestType,
  GetNavigationMenuResponseType,
  GetNavigationMenuErrorType,
  false
> = {
  serviceName: 'com.hubspot.portals.platform.app.rpc.NavigationRpc',
  rpcName: 'getNavigationMenu',
  auth: 'external',
  fingerprint: '2j6RBP_JoLOd9KLG3JsbUmqVobnnONkj',
  na1Only: false,
  isStreaming: false,
  isHublessAppAuth: false,
};
